module.exports = __webpack_public_path__ + "img/sngls.71e23711.svg";